module.exports = __webpack_public_path__ + "static/media/unexpected.42e7cec7.svg";